import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api_url from "../../libary/axios-home";

export const initialState = {
  company: [],
};

export const fetchCompanyByIdApi = createAsyncThunk(
  "getCompanyById/fetchCompanyByIdApi",
  async ({ id }) => {
    try {
      const response = await api_url.get("companies/" + id);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
);

const getCompanyByIdSlice = createSlice({
  name: "getCompanyByIdSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchCompanyByIdApi.pending, (state, action) => {
      state.status = "loading";
      // Add user to the state array
    });
    builder.addCase(fetchCompanyByIdApi.fulfilled, (state, action) => {
      // Add user to the state array
      state.status = "succeeded";
      state.company = action.payload;
    });
    builder.addCase(fetchCompanyByIdApi.rejected, (state, action) => {
      // Add user to the state array
    });
  },
});

export default getCompanyByIdSlice.reducer;
